<template>
    <v-container fluid class="pa-0">
        <PageHeader :contextStyle="contextStyle">
            <template #right><v-btn small rounded color="primary"  :to="{ name: 'quizzes-edit', params: { qiz_id: 0 } }">Ajouter un quiz</v-btn></template>
        </PageHeader>
    
        <QuizForm v-if="( $route.params.qiz_id !== undefined && parseInt( $route.params.qiz_id ) >= 0 )"/>
        <v-card v-else :class="($root.$mobileView) ? 'mt-0 mb-2 ml-0 mr-0 rounded-lg' : 'ma-4 rounded-lg'">
            <QuizList />
        </v-card>
    
    </v-container>
    </template>
    
    <script>
    import PageHeader from '@/components/ui/PageHeader'
    import QuizList  from '@/components/quizzes/QuizList'
    import QuizForm   from '@/components/quizzes/QuizForm'

    export default {
        name: 'quizzes-page',
        props: ['contextStyle'],
        components: {
            PageHeader,
            QuizList, QuizForm
        },
        data: function () {
            return {
            }
        },
        computed: { },
        created(){},
        mounted: function (){
    
        },
        methods: {
    
        },
        beforeDestroy() {
    
        },
    }
    </script>